/* DC Halloween '26 (2026-09-22). Loaded only by the "Page script" field of dc-page-colors on
   templates/collection.seasonal-halloween-26.json, so nothing here reaches another page.

   Renames the Klaviyo reviews carousel heading "Happy customers" to "Terrified customers" on this page only.
   The heading is injected client-side by the Klaviyo app block (h2.kl_reviews__carousel__header, light DOM),
   and changing it in Klaviyo would change it sitewide. Only a text node that equals "happy customers"
   (any case) is touched, and the widget's own casing is kept. Stops after the swap, or after 15 seconds. */
(function () {
  var SEL = '.kl_reviews__carousel__header';
  function cased(v) {
    if (v === v.toUpperCase()) return 'TERRIFIED CUSTOMERS';
    if (v === v.toLowerCase()) return 'terrified customers';
    return 'Terrified customers';
  }
  function swap() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      for (var n = els[i].firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && /^\s*happy customers\s*$/i.test(n.nodeValue)) {
          var v = n.nodeValue.trim();
          n.nodeValue = n.nodeValue.replace(v, cased(v));
          return true;
        }
      }
    }
    return false;
  }
  if (swap()) return;
  var mo = new MutationObserver(function () { if (swap()) mo.disconnect(); });
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();
